import { render, staticRenderFns } from "./reporteCobranza.vue?vue&type=template&id=95b047e8"
import script from "./reporteCobranza.vue?vue&type=script&lang=js"
export * from "./reporteCobranza.vue?vue&type=script&lang=js"
import style0 from "./reporteCobranza.vue?vue&type=style&index=0&id=95b047e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports